import { render } from "./HighlightCard.vue?vue&type=template&id=6ebd07ff&scoped=true"
import script from "./HighlightCard.vue?vue&type=script&lang=js"
export * from "./HighlightCard.vue?vue&type=script&lang=js"

import "./HighlightCard.css?vue&type=style&index=0&id=6ebd07ff&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebd07ff"]])

export default __exports__